import { IEnvironment } from './environment.model';

export const environment: IEnvironment = {
  DEV: true,
  STAGING_URL: '',
  API_CACHE: false,
  SENTRY_ENV: 'dev'
};
